
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9 .444C4.415.444.667 4.192.667 8.778c0 4.585 3.748 8.333 8.333 8.333 4.586 0 8.334-3.748 8.334-8.333C17.334 4.192 13.586.444 9 .444zm3.773 10.62a1.05 1.05 0 11-1.486 1.486L9 10.263 6.713 12.55a1.05 1.05 0 01-1.485-1.485l2.287-2.287L5.228 6.49a1.05 1.05 0 011.485-1.486L9 7.292l2.287-2.287a1.05 1.05 0 011.486 1.486l-2.287 2.287 2.287 2.287z","fill":"#FF4954"}})])
          )
        }
      }
    